import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  flightSearchCard: {
    paddingTop: '36px !important',
    paddingRight: '30px !important',
    paddingLeft: '30px !important',
  },
  gridItemInput: {
    padding: '0 15px',
    [Theme.breakpoints.down('lg')]: {
      padding: '20px 10px 20px 10px !important',
    },
    [Theme.breakpoints.down('md')]: {
      padding: '14px 10px 15px 10px !important',
      maxWidth: '50%',
      '& svg': {
        display: 'block',
      },
    },
    [Theme.breakpoints.down('sm')]: {
      padding: '17px 20px 17px 20px !important',
      minWidth: '100%',
      height: '110px',
      '& svg': {
        display: 'block',
      },
    },
    '& .MuiInput-formControl': {
      height: '50px',
      '& .MuiInputBase-input': {
        height: '34px',
      },
    },
    '&.required-error .MuiInput-formControl': {
      borderColor: Theme.palette.error.main,
    },
    '& .MuiFormHelperText-root.Mui-error': {
      fontFamily: Theme.typography.base.regular,
      color: Theme.palette.error.text,
      fontSize: Theme.typography.size[0.5],
    },
  },
  gridItemInputFrom: {
    '& svg.MuiSvgIcon-root': {
      color: Theme.palette.primary.light,
    },
    [Theme.breakpoints.down('sm')]: {
      height: '110px',
      paddingTop: '17px !important',
    },
    [Theme.breakpoints.up('xl')]: {
      paddingLeft: '0',
    },
  },
  gridItemCalendar: {
    padding: '0 15px',
    [Theme.breakpoints.down('lg')]: {
      padding: '20px 10px 20px 10px !important',
    },
    [Theme.breakpoints.down('md')]: {
      padding: '13px 10px 20px 10px !important',
      maxWidth: '100%',
      height: '113px',
      '& .MuiGrid-item:first-child .MuiInputAdornment-positionStart': {
        display: 'flex',
      },
    },
    [Theme.breakpoints.down('sm')]: {
      padding: '13px 20px 30px 20px !important',
      maxWidth: '100%',
      height: '125px',
    },
    '& .MuiInput-formControl': {
      height: '50px',
      '& .MuiInputBase-input': {
        height: '34px',
      },
    },
  },
  gridButtonWrapper: {
    display: 'flex',
    alignItems: 'center',
    top: '12px',
    position: 'relative',
    paddingLeft: '15px',
    justifyItems: 'flex-end',
    [Theme.breakpoints.only('md')]: {
      '& button': {
        marginLeft: '10px!important',
      },
    },

    [Theme.breakpoints.down('lg')]: {
      padding: '0px 0px 14px !important',
    },
    [Theme.breakpoints.down('md')]: {
      padding: '0px !important',
      maxWidth: '100%',
      top: '0',
      display: 'flex',
      '& button': {
        maxWidth: 'fit-content',
        height: '40px',
      },
    },
    [Theme.breakpoints.down('sm')]: {
      padding: '17px 10px 17px 10px !important',
      display: 'none',
    },
    '& button': {
      marginTop: '10px',
      paddingLeft: '15px',
      paddingRight: '15px',
      [Theme.breakpoints.only('md')]: {
        height: '56px',
        padding: '0px 24px',
      },
      [Theme.breakpoints.only('lg')]: {
        marginLeft: '10px !important',
      },
      [Theme.breakpoints.only('xl')]: {
        margin: 'initial !important',
      },
      [Theme.breakpoints.up('xl')]: {
        width: '100%',
      },
    },
  },
  gridButtonMobileWrapper: {
    display: 'none',
    [Theme.breakpoints.down('sm')]: {
      display: 'block',
      width: '100%',
      '& button': {
        fontSize: `${Theme.typography.size[3]} !important`,
        height: '50px',
        width: '100%',
      },
    },
  },
  gridButton: {
    '& > span': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      fontSize: Theme.typography.size[2],
      fontFamily: Theme.typography.base.regular,
    },
  },
  inlineMenu: {
    [Theme.breakpoints.up('md')]: {
      display: 'flex',
      flexDirection: 'column',
    },
    [Theme.breakpoints.only('xl')]: {
      flexDirection: 'row',
      marginBottom: '20px',
      alignItems: 'center',
    },
    '& > div:first-child': {
      [Theme.breakpoints.only('xl')]: {
        display: 'contents',
      },
    },
    '& .MuiBox-root': {
      width: 'auto',
      display: 'inline-flex',

      '& > button': {
        paddingRight: '0',
        [Theme.breakpoints.up('xl')]: {
          marginTop: '0',
          marginBottom: '0',
        },
      },
    },
  },
  dateAndShip: {
    display: 'block',
    color: Theme.palette.gray[750],
    fontSize: Theme.typography.size[1],
    marginLeft: '20px',
    fontFamily: Theme.typography.base.regular,
    textAlign: 'left',
    [Theme.breakpoints.down('sm')]: {
      marginLeft: '0',
      paddingLeft: '0 !important',
      paddingRight: '20px',
    },
    [Theme.breakpoints.only('md')]: {
      padding: '16px 0px 10px',
      marginLeft: '0',
    },
    [Theme.breakpoints.only('lg')]: {
      padding: '16px 0px 9px',
      marginLeft: '0',
    },
  },
  dateAndShipSemibold: {
    fontFamily: Theme.typography.base.semiBold,
  },
  counterMenu: {
    [Theme.breakpoints.down('sm')]: {
      marginBottom: '15px',
    },
  },
  requiredFieldError: {
    fontFamily: Theme.typography.base.regular,
    color: Theme.palette.error.text,
    fontSize: Theme.typography.size[0.5],
    marginTop: '4px',
    textAlign: 'start',
  },
}));

export default useStyles;
